<template>
  <g fill-rule="evenodd">
    <path
      d="M14.04 9.04h-3.08V5.96a.96.96 0 10-1.92 0v3.08H5.96a.96.96 0 100 1.92h3.08v3.08a.96.96 0 101.92 0v-3.08h3.08a.96.96 0 100-1.92"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "CreateIcon",
});
</script>
